module.exports = __webpack_public_path__ + "img/9.2707fa4a.jpg";